<p-dialog
  [(visible)]="display"
  [style]="{ width: '45vw' }"
  (onHide)="closeTargetCompletionDate()"
  [modal]="true"
  id=""
>
  <div *ngIf="errorMessage.length > 0">
    <p-messages severity="error">
      <ng-template pTemplate>
        <span class="p-message-icon pi pi-times-circle"></span>
        <span class="p-ml-2">Please correct the following error</span>
        <ul>
          <li>{{ errorMessage }}</li>
        </ul>
      </ng-template>
    </p-messages>
  </div>
  <ng-template pTemplate="header">
    Change Control Target Completion Date
  </ng-template>
  <div class="mt-2">
    <bpt-datetime
      appendTo="'body'"
      id="targetCompletionDateInput"
      [minDate]="minDateValue.toString()"
      placeholder="Enter or select a date"
      label="Target Completion Date"
      [(ngModel)]="targetCompletionDate"
      [required]="true"
    ></bpt-datetime>
  </div>
  <ng-template pTemplate="footer">
    <p-button
      appPreventDoubleClick
      label="Confirm"
      type="submit"
      id="saveTargetCompletionDateButton"
      class="align-right"
      (debounceClick)="saveTargetCompletionDate()"
    >
    </p-button>
  </ng-template>
</p-dialog>
